import { APIModel } from 'app/state/api';
import { ApiCallModel } from 'app/state/api/interfaces';

const updateOrg: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_AUTH_API}/edit-group`),
};

export default updateOrg;
